import * as constants from './constants';

/* Get project users */
export const getUsers = (projectId, callback) => ({
  type: constants.GET_USERS,
  projectId,
  callback
});

export const getUsersSuccess = (projectId, users) => ({
  type: constants.GET_USERS_SUCCESS,
  projectId,
  users
});

export const getUsersError = (projectId, error) => ({
  type: constants.GET_USERS_ERROR,
  projectId,
  error
});

/* Add project user */
export const addUser = (projectId, user, actions) => ({
  type: constants.ADD_USER,
  projectId,
  user,
  actions
});

export const addUserSuccess = (projectId) => ({
  type: constants.ADD_USER_SUCCESS,
  projectId
});

export const addUserError = (projectId, error) => ({
  type: constants.ADD_USER_ERROR,
  projectId,
  error
});

/* Remove project users */
export const removeUsers = (projectId, userIds) => ({
  type: constants.REMOVE_USERS,
  projectId,
  userIds
});

export const removeUsersSuccess = (projectId) => ({
  type: constants.REMOVE_USERS_SUCCESS,
  projectId
});

export const removeUsersError = (projectId, error) => ({
  type: constants.REMOVE_USERS_ERROR,
  projectId,
  error
});

/* Reset project users */
export const resetUsers = (projectId, userIds) => ({
  type: constants.RESET_USERS,
  projectId,
  userIds
});

export const resetUsersSuccess = (projectId) => ({
  type: constants.RESET_USERS_SUCCESS,
  projectId
});

export const resetUsersError = (projectId, error) => ({
  type: constants.RESET_USERS_ERROR,
  projectId,
  error
});
